// extracted by mini-css-extract-plugin
export default {"app-container":"src_app-container__6dzJl","main-content":"src_main-content__hAB6h","home-background":"src_home-background__jMxv9"};